import React from "react";
import LGWashingPageTemplate from "./LGWashingPageTemplate";

const relatedLinks = [
  { to: "/lg-appliance-service-bangalore", label: "LG Appliance Service" },
  { to: "/lg-washing-machine-service-bangalore", label: "LG Washing Machine Service" },
  { to: "/lg-washing-machine-repair-bangalore", label: "LG Washing Machine Repair" },
  { to: "/lg-washing-machine-not-spinning", label: "LG Washing Machine Not Spinning" },
  { to: "/lg-top-load-washing-machine-service-bangalore", label: "LG Top Load Service" },
];

const LGFrontLoadService = () => {
  return (
    <LGWashingPageTemplate
      title="LG Front Load Washing Machine Service in Bangalore"
      description="LG front load washing machine service in Bangalore with support for drainage issues, drum faults, door lock errors, and vibration problems."
      keywords="lg front load washing machine service bangalore, lg front load repair, lg washer service"
      path="/lg-front-load-washing-machine-service-bangalore"
      bannerTitle="LG Front Load Service in Bangalore"
      intro={<>We provide <span style={{ fontWeight: 'bold' }}>LG front load washing machine service in Bangalore</span> for advanced drum systems, water flow problems, noise complaints, and wash cycle errors. Our technicians work on inspection, repair, and maintenance for <span style={{ fontWeight: 'bold' }}>front load models</span>.</>}
      highlights={[
        "Door lock, gasket, and drainage support",
        "Drum, bearing, and vibration-related repair",
        "Sensor and PCB fault inspection",
        "Cleaning and maintenance for front load units",
      ]}
      issues={[
        "Water not draining fully",
        "Excess vibration or noise",
        "Door lock or seal problems",
        "Wash cycle stopping midway",
      ]}
      relatedLinks={relatedLinks}
    />
  );
};

export default LGFrontLoadService;
